import styled, { css } from 'styled-components';

export const ClickableSpan = styled.span`
  ${({ onClick }) =>
    onClick != null
      ? css`
          cursor: pointer;
          transition: color 0.2s ease-in-out;

          &:hover {
            color: white;
          }
        `
      : css`
          cursor: text;
        `};
`;
